/** Isolated git worktree layout under `{worktreesRoot}/{bridgeKey}/…`. */
export type WorktreeLayoutKind = 'session' | 'preview_environment';

export function sanitizeWorktreeBranchSegment(value: string): string {
  return value.replace(/[^a-zA-Z0-9/_-]+/g, '-').slice(0, 80) || 'worktree';
}

/** Directory segments under `{bridgeKey}/` for this worktree kind. */
export function layoutDirSegments(kind: WorktreeLayoutKind, id: string): string[] {
  const trimmed = id.trim();
  switch (kind) {
    case 'session':
      return [trimmed];
    case 'preview_environment':
      return ['preview', trimmed];
  }
}

/** Default branch name when first creating isolated worktrees for a session or preview environment. */
export function defaultBranchNameForLayoutKind(kind: WorktreeLayoutKind, id: string): string {
  const safe = sanitizeWorktreeBranchSegment(id.trim());
  switch (kind) {
    case 'session':
      return `session-${safe}`;
    case 'preview_environment':
      return `preview-${safe}`;
  }
}

/** Branch checked out in a preview environment worktree after deploying a session. */
export function previewDeployBranchName(environmentId: string): string {
  return `preview-deploy-${sanitizeWorktreeBranchSegment(environmentId.trim())}`;
}
